module.exports = __webpack_public_path__ + "img/39.72be44c7.jpg";